<template>
    <table class="mg-table-market-data-interactive text-sm heading-font border-separate" v-if="topTenMarkets.length">
        <thead>
            <tr class="uppercase antialiased text-sm text-white tracking-medium border-b-0">
                <th class="border-b-0 hidden xl:table-cell md-chart-wrapper__label-cell"></th>
                <th class="border-b-0 font-normal p-0 xl:w-36 mg-banded-primary-darker" scope="col"><span class="block px-4 py-2">Previous Market Year ({{marketDataSettings.previous_market_year_label}})</span></th>
                <th class="border-b-0 font-normal p-0 xl:w-36 mg-banded-primary" scope="col"><span class="px-4 py-2 block">Current Market Year ({{marketDataSettings.current_market_year_label}})</span></th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="export_totals && displayRow('World Total')" class="border-0 tracking-medium text-sm md:text-base mg-table-market-data-interactive__all-row">
                <td class="p-0 hidden xl:table-cell relative button-cell md-chart-wrapper__label-cell" :style="{'background-color': colors[0]}">
                    <div class="cell-inner-wrap">
                        <button @click="trigger('World Total')" :class="[{active: activePartners.indexOf('World Total') > -1}]" class="plain-button rounded-none antialiased text-center cell-inner p-2 absolute pin">
                            <span :class="[{'text-shadow-sm': activePartners.indexOf('World Total') > -1}]" class="text-base leading-none font-bold">World Total</span>
                        </button>
                    </div>
                </td>
                <td class="p-0 border-l-8 border-r-8 mg-border-primary-darker align-bottom">
                    <div class="cell-inner p-2">
                        <div>
                            {{formatNumber(export_totals[top_exports_selected]['previous_market_year_quantity'])}}
                        </div>
                        
                        <span :class="{'visible': showDollars, 'invisible': !showDollars}">$</span><transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"><span v-if="showDollars">{{formatNumber(export_totals[top_exports_selected]['previous_market_year_value'])}}</span></transition>
                        
                    </div>
                </td>
                <td class="p-0 border-l-8 border-r-8 mg-border-primary">
                    <div class="cell-inner p-2 relative">
                        <div class="pr-8">
                            <div class="absolute pin-t pin-r mt-1 mr-1 text-xs md-chart-wrapper__change" :class="{'success-color': export_totals[top_exports_selected]['change'] > 0, 'error-color': export_totals[top_exports_selected]['change'] <= 0}">
                                <svg v-if="getPercent(export_totals[top_exports_selected]['change']) != 'N/A'" class="mg-icon">
                                    <use :href="getArrowName(export_totals[top_exports_selected]['change'])" :xlink:href="getArrowName(export_totals[top_exports_selected]['change'])" />
                                </svg> {{getPercent(export_totals[top_exports_selected]['change'])}}
                            </div>
                            {{formatNumber(export_totals[top_exports_selected]['current_market_year_quantity'])}}
                        </div>
                        
                        <span :class="{'visible': showDollars, 'invisible': !showDollars}">$</span><transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"><span v-if="showDollars">{{formatNumber(export_totals[top_exports_selected]['current_market_year_value'])}}</span></transition>
                    </div>
                </td>
            </tr>
            <tr v-for="(partner, index) in topTenMarkets" :key="index" class="border-0 tracking-medium text-sm md:text-base" :class="[
            {'mg-table-market-data-interactive__all-row': index == 0}]" v-if="partner[top_exports_selected] && displayRow(partner.market_name)">
                <td class="p-0 hidden xl:table-cell relative button-cell md-chart-wrapper__label-cell" :style="{'background-color': colors[index + 1]}">
                    <div class="cell-inner-wrap">
                        <button @click="trigger(partner.market_name)" :class="[{active: activePartners.indexOf(partner.market_name) > -1}]" class="plain-button rounded-none antialiased text-left cell-inner p-2 absolute pin flex items-center button-cell__button">
                            <span :class="`flag-icon-${handleCountryCode(partner.market_code)}`" class="w-8 h-8 flag-icon button-cell__mg-icon absolute"></span>
                            <span :class="[{'text-shadow-sm': activePartners.indexOf(partner.market_name) > -1}]" class="text-base leading-none font-bold">{{partner.market_name}}</span>
                        </button>
                    </div>
                </td>
                <td class="p-0 border-l-8 border-r-8 mg-border-primary-darker align-bottom">
                    <div class="cell-inner p-2">
                        <div>
                            {{formatNumber(partner[top_exports_selected]['previous_market_year_quantity'])}}
                        </div>
                        
                        <span :class="{'visible': showDollars, 'invisible': !showDollars}">$</span><transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"><span v-if="showDollars">{{formatNumber(partner[top_exports_selected]['previous_market_year_value'])}}</span></transition>
                    </div>
                </td>
                <td class="p-0 border-l-8 border-r-8 mg-border-primary">
                    <div class="cell-inner p-2 relative">
                        <div class="pr-8">
                            <div class="absolute pin-t pin-r mt-1 mr-1 text-xs md-chart-wrapper__change" :class="{'success-color': partner[top_exports_selected]['change'] > 0, 'error-color': partner[top_exports_selected]['change'] <= 0}">
                                <svg v-if="getPercent(partner[top_exports_selected]['change']) != 'N/A'" class="mg-icon">
                                    <use :href="getArrowName(partner[top_exports_selected]['change'])" :xlink:href="getArrowName(partner[top_exports_selected]['change'])" />
                                </svg> {{getPercent(partner[top_exports_selected]['change'])}}
                            </div>
                            {{formatNumber(partner[top_exports_selected]['current_market_year_quantity'])}}
                        </div>

                        <span :class="{'visible': showDollars, 'invisible': !showDollars}">$</span><transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"><span v-if="showDollars">{{formatNumber(partner[top_exports_selected]['current_market_year_value'])}}</span></transition>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>   
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import numeral from "numeral";

import getCountryCode from "../utilities/get-country-code";
import formatNumber from "../utilities/format-number";
import getArrowName from "../utilities/get-svg-arrow-name";
import getPercent from "../utilities/get-percent";

export default {
    name: "market-data-partners",
    computed: {
        ...mapState([
            "isDesktop",
            "showQty",
            "showDollars",
            "activePartners",
            "top_exports_selected",
            "colors",
            "export_totals",
            "marketDataSettings"
        ]),
        ...mapGetters(["topTenMarkets"])
    },
    methods: {
        ...mapMutations(["removeActivePartner", "addActivePartner"]),
        formatNumber: formatNumber,
        getArrowName: getArrowName,
        getPercent: getPercent,
        displayRow(key) {
            if (!this.isDesktop && this.activePartners.indexOf(key) == -1) {
                return false;
            } else {
                return true;
            }
        },
        trigger(key) {
            const keyActiveIndex = this.activePartners.indexOf(key);
            if (keyActiveIndex > -1) {
                this.removeActivePartner(keyActiveIndex);
            } else {
                this.addActivePartner(key);
            }
        },
        handleCountryCode(countryCode) {
            return getCountryCode(countryCode);
        }
    },
    created() {
        this.addActivePartner("World Total");
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/market-data-partners.vue